'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
export default function DepartmentMenu() {
  const t = useTranslations('Navbar');
  const departments = [{
    name: t('lipogems.name'),
    description: t('lipogems.description'),
    icon: '/images/icons/lipogems.png',
    href: '/department/lipogems'
  }, {
    name: t('surgery.name'),
    description: t('surgery.description'),
    icon: '/images/icons/surgery.png',
    href: '/department/regenerative-surgery'
  }, {
    name: t('longevity.name'),
    description: t('longevity.description'),
    icon: '/images/icons/human-performance.png',
    href: '/department/longevity'
  }, {
    name: t('aestheticMedicine.name'),
    description: t('aestheticMedicine.description'),
    icon: '/images/icons/aesthetic-medicine.png',
    href: '/department/aesthetic-medicine'
  }, {
    name: t('advancedAesthetics.name'),
    description: t('advancedAesthetics.description'),
    icon: '/images/icons/aesthetic-therapy.png',
    href: '/department/advanced-aesthetics'
  }, {
    name: t('integrativePrograms.name'),
    description: t('integrativePrograms.description'),
    icon: '/images/icons/integrative-programs.png',
    href: '/department/integrative-programs'
  }];
  return <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 md:gap-4" data-sentry-component="DepartmentMenu" data-sentry-source-file="department-menu.tsx">
      {departments.map(dept => <Link key={dept.name} href={dept.href} className="flex h-full hover:bg-offbluish p-2 md:p-4 rounded-lg transition-colors duration-200">
          <div className="flex items-center">
            <div className="mr-4">
              <Image src={dept.icon} alt={dept.name} width={40} height={40} className="w-12 md:w-20 h-auto" />
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1 hidden md:block">{dept.description}</p>
              <h4 className="text-xl md:text-3xl">{dept.name}</h4>
            </div>
          </div>
        </Link>)}
    </div>;
}